import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"../../packages/ui-pages/src/fonts/index.ts\",\"import\":\"Montserrat_Alternates\",\"arguments\":[{\"weight\":[\"400\",\"500\",\"600\"],\"subsets\":[\"cyrillic\"],\"variable\":\"--font-montserrat-alternates\"}],\"variableName\":\"montserratAlternates\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"../../packages/ui-pages/src/fonts/index.ts\",\"import\":\"Comfortaa\",\"arguments\":[{\"weight\":[\"300\",\"400\",\"500\"],\"subsets\":[\"cyrillic\"],\"variable\":\"--font-comfortaa\"}],\"variableName\":\"comfortaa\"}");
;
import(/* webpackMode: "eager" */ "/app/packages/ui-pages/src/components/footer/icons/instagram.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/ui-pages/src/components/footer/icons/telegram.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/ui-pages/src/components/footer/icons/youtube.svg");
;
import(/* webpackMode: "eager", webpackExports: ["ActionButtons"] */ "/app/packages/ui-pages/src/project/page/components/hero/action-buttons.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui-pages/src/project/page/components/metrics/images/group.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/ui-pages/src/project/page/components/updated-at.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui-pages/src/project/page/images/bg-camo.png");
;
import(/* webpackMode: "eager" */ "/app/packages/ui-pages/src/project/page/images/image-group-big.png");
;
import(/* webpackMode: "eager" */ "/app/packages/ui-pages/src/project/page/images/image-group-small.png");
;
import(/* webpackMode: "eager" */ "/app/packages/ui-pages/src/project/page/images/no-cover.png");
;
import(/* webpackMode: "eager" */ "/app/packages/ui-pages/src/project/page/vector-images/bg-image-planets.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/ui-pages/src/project/page/vector-images/bg-image-space-planet.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/ui-pages/src/project/page/vector-images/bg-image-tank.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/components/image-with-fallback.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/images/logo.png");
